import { gql } from "@apollo/client";

const CHANGE_EWP_API = gql`
  mutation changeEWPAPIs($api_iia: Boolean!, $api_ola: Boolean!, $api_static: Boolean!, $api_ounits: Boolean!, $api_nomination: Boolean!) {
    changeEWPAPIs(api_iia: $api_iia, api_ola: $api_ola, api_static: $api_static, api_ounits: $api_ounits, api_nomination: $api_nomination)
  }
`;

export default CHANGE_EWP_API;
